import { render, staticRenderFns } from "./CollectionProducts.vue?vue&type=template&id=014f0b06&scoped=true&"
import script from "./CollectionProducts.vue?vue&type=script&lang=ts&"
export * from "./CollectionProducts.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionProducts.vue?vue&type=style&index=0&id=014f0b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014f0b06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent,VListItemTitle})
